<template>
  <div class="page">
    <div class="pagebanner pagebanner1" :style="{background:'url('+pagebanner+') center 0 no-repeat'}">
      <div class="w1200">
        <h1 class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0">{{pagetitle}}</h1>
        <span class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0.2s">{{pagedesc}}</span>
      </div>
    </div>
    <div class="page-location">
      <div class="w1200">
        <ul class="pagenav">
          <li>
            <a href="javascript:;" @click="$router.push({name: 'prodlist'})">{{ $t('product')}}</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({name: 'quality'})">{{ $t('quality')}}</a>
          </li>
          <li class="s">
            <a href="javascript:;" @click="$router.push({name: 'application'})">{{ $t('application')}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="box1">
      <div class="w1348">
        <div class="w1200">
          <div class="box1-title">
            {{ $t('applictiontitle')}}
          </div>
          <div class="swiper-containera">
            <div class="swiper-wrapper">
              <div class="swiper-slide bounceInUp wow" data-wow-duration="1s" data-wow-delay="1s" v-for="(item,index) in product" :key="index">
                <img :src="item.image" alt="">
                <span>{{item.title}}</span>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-paginationa"></div>
          </div>
        </div>
        <div class="swiper-button-preva"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-button-nexta"></div>
      </div>
    </div>
    <div class="page-main">
      <div class="w1200">
        <div class="page-content" v-html="content">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import Fetch from '../js/ajax'
export default {
  name: 'Environment',
  metaInfo () {
    return {
      meta: [{
        name: 'keywords',
        content: '浙江金科日化原料有限公司,氧系漂白助剂过碳酸钠,SPC'
      }]
    }
  },
  data () {
    return {
      pagetitle: '',
      pagedesc: '',
      pagebanner: '',
      product: [],
      title: '',
      content: ''
    }
  },
  mounted () {
  },
  methods: {
  },
  created () {
    const that = this
    Fetch.post('Api/column', {
      id: 2
    }).then((res) => {
      that.pagetitle = res.result.title
      that.pagedesc = res.result.sub_title
      that.pagebanner = res.result.image
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/field', {
    }).then((res) => {
      that.product = res.result
      that.content = res.result[0].content
      setTimeout(function () {
        var myswipera = new Swiper('.swiper-containera', {// eslint-disable-line no-unused-vars
          loop: true,
          slidesPerView: 'auto',
          loopedSlides: 6,
          centeredSlides: true,
          navigation: {
            nextEl: '.swiper-button-nexta',
            prevEl: '.swiper-button-preva'
          },
          pagination: {
            el: '.swiper-paginationa',
            clickable: true
          },
          on: {
            slideChangeTransitionEnd: function () {
              console.log(this.activeIndex)
              if (this.activeIndex === 6 || this.activeIndex === 12) {
                that.content = that.product[0].content
              } else {
                that.content = that.product[this.activeIndex - 6].content
              }
            }
          }
        })
      })
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-main{
    min-height: 400px;
    padding: 0 40px;
    overflow: hidden;
  }
  .pagebanner{
    height: 600px;
    overflow: hidden;
  }
  .pagebanner2{
    background: url(../assets/pagebanner2.png) center 0 no-repeat;
  }
  .pagebanner h1{
    height: 60px;
    display: block;
    line-height: 60px;
    margin-top: 271px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #fff;
  }
  .pagebanner span{
    overflow: hidden;
    height: 41px;
    display: block;
    line-height: 41px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .page-location{
    height: 60px;
    background-color: #F4F4F4;
  }
  .pagenav{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content:center;
  }
  .pagenav li{
    width: 168px;
    height: 60px;
    margin: 0 3px;
  }
  .pagenav li a{
    display: block;
    width: 100%;
    height: 100%;
    line-height: 60px;
    text-align: center;
    color: #999999;
    font-size: 14px;
  }
  .pagenav .s a,.pagenav li:hover a{
    color: #E40A1F;
    font-size: 16px;
    font-weight: bold;
    background-color: #fff;
  }
  .page-content{
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0 30px;
  }
  .box1{
    height: 480px;
  }
  .swiper-containera{
    height: 350px;
  }
  .swiper-containera .swiper-slide{
    width: 240px;
    height: 350px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 15px;
  }
  .swiper-containera .swiper-slide img{
    width: 100%;
    height: auto;
  }
  .swiper-containera .swiper-slide span{
    font-size: 16px;
    color: #333333;
    display: block;
    height: 54px;
    line-height: 54px;
  }
  .swiper-containera .swiper-slide-active img{
    width: 100%;
  }
  .swiper-containera .swiper-slide-active {
    padding-left: 0;
  }
  .swiper-containera .swiper-slide-active span{
    font-weight: bold;
    color: #000;
  }
  .w1348{
    width: 1348px;
    margin: 75px auto 0 auto;
    position: relative;
  }
  .swiper-button-nexta{
    width: 20px;
    height: 60px;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -30px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    transform: rotate(180deg);
    transform-origin: 50% 50%;
    z-index: 20;
  }
  .swiper-button-nextb{
    width: 20px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -30px;
    margin-left: 680px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    transform: rotate(180deg);
    transform-origin: 50% 50%;
    z-index: 20;
  }
  .swiper-button-prevb{
    width: 20px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -30px;
    margin-left: -700px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    z-index: 20;
  }
  .swiper-button-preva{
    width: 20px;
    height: 60px;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -30px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    z-index: 20;
  }
  .swiper-button-nexta:hover,.swiper-button-preva:hover,.swiper-button-nextb:hover,.swiper-button-prevb:hover{
    background:url(../assets/jiantouh.png) 0 0 no-repeat;
  }
  .box1-title{
    width: 100%;
    height: 30px;
    margin-bottom: 40px;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/application.vue